import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  {
    label:
      'This questionnaire will assess your symptom resolution while on your current therapy. If you are having any side effects an adjustment in your regimen may be needed',
    field: 'hrt3MonthsFollowup_Intro',
    type: 'info',
    answer: {}
  },

  {
    label: 'If you are on progesterone which regimen are you using?',
    field: 'hrt3MonthsFollowup_ifYouAreOnProgesteroneWhichRegimenAreYouUsing',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'cyclic (I take progesterone for 14 days)',
          key: 'cyclic'
        },
        {
          value: 'continuous (I take progesterone every day)',
          key: 'continuous'
        },
        {
          value: 'I am not taking progesterone',
          key: 'iAmNotTakingProgesterone'
        }
      ]
    }
  },

  {
    label: 'Are you experiencing vaginal bleeding',
    field: 'hrt3MonthsFollowup_areYouExperiencingVaginalBleeding1',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'A little breakthrough bleeding',
          key: 'aLittleBreakthroughBleeding'
        },
        {
          value: 'I am experiencing heavy bleeding',
          key: 'iAmExperiencingHeavyBleeding'
        },
        {
          value: 'I am bleeding only when taking progesterone',
          key: 'iAmBleedingOnlyWhenTakingProgesterone'
        },
        {
          value: 'I am bleeding when I am taking estrogen',
          key: 'iAmBleedingWhenIAmTakingEstrogen'
        },
        {
          value: 'I am not experiencing bleeding',
          key: 'iAmNotExperiencingBleeding'
        }
      ]
    }
  },

  {
    label: 'Are you experiencing vaginal bleeding',
    field: 'hrt3MonthsFollowup_areYouExperiencingVaginalBleeding2',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'A little breakthrough bleeding',
          key: 'aLittleBreakthroughBleeding'
        },
        {
          value: 'I am experiencing heavy bleeding',
          key: 'iAmExperiencingHeavyBleeding'
        },
        {
          value: 'I am not experiencing bleeding',
          key: 'iAmNotExperiencingBleeding'
        }
      ]
    }
  },

  {
    label: 'are you experiencing the following symptoms',
    field: 'hrt3MonthsFollowup_areYouExperiencingTheFollowingSymptoms',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          value: 'breast tenderness',
          key: 'breastTenderness'
        },
        {
          value: 'bloating',
          key: 'bloating'
        },
        {
          value: 'mood changes',
          key: 'moodChanges'
        },
        {
          value: 'drowsiness',
          key: 'drowsiness'
        },
        {
          key: 'noneOfTheSymptoms',
          value: 'None of the above',
          uncheckOthers: true
        }
      ]
    }
  },

  {
    label: 'are you experiencing vaginal symptoms',
    field: 'hrt3MonthsFollowup_areYouExperiencingVaginalSymptoms',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          value: 'dryness',
          key: 'dryness'
        },
        {
          value: 'irritation',
          key: 'irritation'
        },
        {
          value: 'itching',
          key: 'itching'
        },
        {
          value: 'burning',
          key: 'burning'
        },
        {
          key: 'none',
          value: 'None of the above',
          uncheckOthers: true
        }
      ]
    }
  },

  {
    label: 'is intercourse painful?',
    field: 'hrt3MonthsFollowup_isIntercoursePainful',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'Intercourse is not painful',
          key: 'intercourseIsNotPainful'
        },
        {
          value: 'Intercourse is rarely painful',
          key: 'intercourseIsRarelyPainful'
        },
        {
          value: 'intercourse is sometimes painful',
          key: 'intercourseIsSometimesPainful'
        },
        {
          value: 'intercourse is nearly always or always painful',
          key: 'intercourseIsNearlyAlwaysOrAlwaysPainful'
        }
      ]
    }
  },

  {
    label: 'How is your mood?',
    field: 'hrt3MonthsFollowup_howIsYourMood',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'iFeelStable', value: 'I feel stable' },
        {
          key: 'sometimesIFeelLikeMyMoodIsChanging',
          value: 'Sometimes I feel like my mood is changing'
        },
        {
          key: 'myMoodIsConstantlyChanging',
          value: 'My mood is constantly changing'
        }
      ]
    }
  },

  {
    label: 'Do you experience headaches?',
    field: 'hrt3MonthsFollowup_doYouExperienceHeadaches',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'occasionalHeadaches', value: 'occasional headaches' },
        {
          key: 'headachesWhenITakeProgesteroneOnlyIfOnACyclicRegimen',
          value:
            'headaches when I take progesterone only (if on a cyclic regimen)'
        },
        { key: 'noHeadaches', value: 'no headaches' }
      ]
    }
  },

  {
    label: 'Do you have hot flashes',
    field: 'hrt3MonthsFollowup_doYouHaveHotFlashes',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'hotFlashesTheSameAsBefore',
          value: 'hot flashes the same as before'
        },
        {
          key: 'hotFlashesSlightlyImprovedFromBefore',
          value: 'hot flashes slightly improved from before'
        },
        {
          key: 'hotFlashesGreatlyImproved',
          value: 'hot flashes greatly improved'
        },
        {
          key: 'hotFlashesResolvedWithTreatment',
          value: 'hot flashes resolved with treatment'
        },
        { key: 'iNeverHadHotFlashes', value: 'I never had hot flashes' },
        {
          key: 'iHaveNewHotFlashesButDidNotBefore',
          value: "I have new hot flashes but didn't before"
        }
      ]
    }
  },

  {
    label: 'How is your sleep',
    field: 'hrt3MonthsFollowup_howIsYourSleep',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'couldBeBetter', value: 'Could be better' },
        { key: 'noChanges', value: 'No changes' },
        { key: 'significantlyWorsened', value: 'Significantly worsened' }
      ]
    }
  },

  {
    label:
      'Has there been any changes to your health? (New diagnosis, recent hospital visit, new clot event)',
    field:
      'hrt3MonthsFollowup_hasThereBeenAnyChangesToYourHealthNewDiagnosisRecentHospitalVisitNewClotEvent',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    }
  },

  {
    label: 'Have you started any new medications?',
    field: 'hrt3MonthsFollowup_haveYouStartedAnyNewMedications',
    type: 'info',
    answer: {
      type: 'text',
      name: 'haveYouStartedAnyNewMedicationsDesc',
      placeholder: ''
    }
  }
];

export default questionsModels;
